import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {errorToast, warnToast} from "../utils/toasts";
import BackEnd from "../backend/BackEnd";

const $ = window.jQuery;
const ymaps = window.ymaps;
const geoCoderNodeTypes = [
    "Country",
    "AdministrativeArea",
    "SubAdministrativeArea",
    "Locality",
    "Thoroughfare",
    "Premise",
    "DependentLocality"
];

class AddressSelector extends Component {
    static propTypes = {
        precision: PropTypes.oneOf(['address', 'region']),
        value: PropTypes.object,
        onChange: PropTypes.func
    };
    static defaultProps = {
        precision: 'address'
    };
    state = {
        useYMaps: !!ymaps,
        address: this.props.value || {}
    };

    componentDidMount() {
        this.$el = $(this.el);
        this.$el.typeahead({
            items: 10,
            minLength: 3,
            source: (query, process) => this.typeaheadSource(query, process),
            displayText: item => item.value,
            matcher: () => true,
            afterSelect: () => this.typeaheadSelect()
        });
    }

    render() {
        const {value, onChange, ...props} = this.props;
        return (
            <input ref={el => this.el = el} type="text" autoComplete="off" {...props} />
        );
    }

    async typeaheadSource(query, process) {
        const searchTerm = this.$el.val();
        if (searchTerm) {
            if (this.state.useYMaps) {
                try {
                    let items = await ymaps.suggest(query);
                    let res = await fetch(`https://geocode-maps.yandex.ru/1.x/?format=json&geocode=${query}`);
                    let json = await res.json();

                    const data = json.response.GeoObjectCollection.featureMember;
                    if (data[0] && data[0].GeoObject) {
                        const geoObject = data[0].GeoObject;

                        if (geoObject.metaDataProperty && geoObject.metaDataProperty.GeocoderMetaData) {
                            const text = geoObject.metaDataProperty.GeocoderMetaData.text;

                            if (text.toLowerCase().indexOf(query.toLowerCase()) !== -1)
                                if (!items.map(x => x.value.toLowerCase().trim()).includes(text.toLowerCase().trim()))
                                    items.unshift({value: text});
                        }
                    }

                    process(items);
                }
                catch (error) {
                    this.setState({useYMaps: false}, () => {
                        console.log('Error getting suggestions for address. Switching to server-side suggestions.', error);
                        this.typeaheadSource(query, process);
                    });
                }
            }
            else {
                let suggest = new BackEnd.Geocoder.Suggest();
                let items = await suggest.call({query});

                process(items);
            }
        } else {
            this.updateAddress({});
        }
    }

    async typeaheadSelect() {
        let query = this.$el.val();

        if (this.state.useYMaps) {
            try {
                let res = await fetch(`https://geocode-maps.yandex.ru/1.x/?format=json&geocode=${query}`);
                let json = await res.json();
                let data = json.response.GeoObjectCollection.featureMember;
                if (!data || !data[0]) {
                    errorToast("К сожалению, выбранный вами адрес не удалось разобрать. Попробуйте другой адрес.");
                    this.updateAddress({});
                    return;
                }

                let geoObject = data[0].GeoObject;
                let addressDetails = geoObject.metaDataProperty.GeocoderMetaData.AddressDetails;
                let shortNameCandidate = "";
                let lastShortNameCandidate = null;

                let tryGet = (obj, property) => {
                    if (obj[property]) {
                        let postAddition = property === "Premise" ? "Number" : "Name";
                        return obj[property][property + postAddition];
                    }
                    return -1;
                };

                let getAddrString = (addr, currentString) => {
                    if (currentString === undefined)
                        currentString = "";

                    for (let i = 0; i < geoCoderNodeTypes.length; i++) {
                        let result = tryGet(addr, geoCoderNodeTypes[i]);
                        if (result !== -1) {
                            currentString += (currentString === "" ? "" : ", ") + result;
                            if (geoCoderNodeTypes[i] === "AdministrativeArea" ||
                                geoCoderNodeTypes[i] === "Locality" ||
                                geoCoderNodeTypes[i] === "DependentLocality") {
                                if ((geoCoderNodeTypes[i] === "DependentLocality" &&
                                        lastShortNameCandidate == null) ||
                                    (geoCoderNodeTypes[i] !== "DependentLocality"))
                                    if (result != null)
                                        shortNameCandidate = result;

                                lastShortNameCandidate = result;
                            }
                            if (this.props.precision === 'region') {
                                if (geoCoderNodeTypes[i] === "Locality" ||
                                    geoCoderNodeTypes[i] === "DependentLocality") {
                                    return currentString;
                                } else {
                                    return getAddrString(addr[geoCoderNodeTypes[i]], currentString);
                                }
                            } else {
                                return getAddrString(addr[geoCoderNodeTypes[i]], currentString);
                            }
                        }
                    }
                    return currentString;
                };

                let address = {};
                address.strictName = getAddrString(addressDetails);

                address.strictName = address.strictName
                    .replace("Санкт-Петербург, Санкт-Петербург", "Санкт-Петербург")
                    .replace("Москва, Москва", "Москва")
                    .replace("Севастополь, Севастополь", "Севастополь");

                shortNameCandidate = shortNameCandidate
                    .replace("посёлок городского типа ", "")
                    .replace("поселок городского типа ", "")
                    .replace("поселок городского типа ", "")
                    .replace("посёлок ", "")
                    .replace("поселок ", "")
                    .replace("деревня ", "")
                    .replace("село ", "")
                    .replace("хутор ", "")
                    .replace("промзона ", "")
                    .trim();

                let displayName = this.getDisplayName(query, shortNameCandidate);

                address.displayName = displayName;
                address.shortName = shortNameCandidate;
                [address.coordLon, address.coordLat] = geoObject.Point.pos.split(" ");

                this.$el.val("");
                this.$el.focus();
                this.$el.val(displayName);

                if (this.props.precision === 'region') {
                    let res = await fetch(`https://geocode-maps.yandex.ru/1.x/?format=json&geocode=${address.strictName}`);
                    let json = await res.json();
                    let data = json.response.GeoObjectCollection.featureMember;
                    if (data && data[0] && data[0].GeoObject) {
                        let geoObject = data[0].GeoObject;
                        let addressDetails = geoObject.metaDataProperty.GeocoderMetaData.AddressDetails;

                        address.geocoderResponce = {
                            for: displayName,
                            addressDetails: addressDetails
                        };
                        this.updateAddress(address);
                    }
                } else {
                    address.geocoderResponce = {
                        for: displayName,
                        addressDetails: addressDetails
                    };
                    this.updateAddress(address);
                }
            }
            catch (error) {
                this.setState({useYMaps: false}, () => {
                    console.log('Error decoding address. Switching to server-side decoding.', error);
                    this.typeaheadSelect();
                });
            }
        }
        else {
            const {precision} = this.props;

            let getAddress = new BackEnd.Geocoder.GetAddress();
            let address = await getAddress.call({query, precision});

            this.updateAddress(address);
        }
    }

    updateAddress(address) {
        const {onChange} = this.props;

        this.setState({address: {}});
        if (onChange)
            onChange(address);
    }

    getDisplayName(displayName, shortName) {
        if (this.props.precision === 'address') {
            return displayName;
        }
        else if (this.props.precision === 'region') {
            return shortName;
        }

        return null;
    }
}

export default AddressSelector;


// WEBPACK FOOTER //
// ./src/controls/AddressSelector.js